module.exports = __webpack_public_path__ + "fonts/open-sans-v17-latin-regular.de0869e3.woff";